import React from "react";
import UKTable from "./UKTable/UKTable";

export default function UKCard(props) {
    const { uk_data } = props
    const hasSource = Object.keys(uk_data?.source || {}).length > 0;
    if (!hasSource) return null;
    return (
        <div style={{width: "100%", border: '1px solid #dedede', borderRadius: '8px', padding: '16px'}}>
            <p style={{fontSize: "14px", fontWeight: "bold", margin: "0 0 16px 0", padding: 0, color: '#0b1f82'}}>
                Reino Unido - Match por similaridade encontrado
            </p>
            <UKTable uk_data={uk_data.source} />
        </div>
    )
}
